<div class="two-panel-layout">

  <div class="settings">

    <div class="setting-content">
      <span class="setting-name">Cruise Control for {{label}} Offer Sets</span>
      <div class="ad-types-header-input">
        @if (settings) {
          <p-toggleswitch [(ngModel)]="settings.enabled" (ngModelChange)="updateSettings()" />
        }
      </div>
    </div>

    <p-divider />

    <div class="setting-content">
      <span class="setting-name">Create {{label}} Offer Sets As</span>
      <div class="ad-types-header-input">
        @if (settings) {
          <p-selectButton
            [options]="generateAsOptions"
            [(ngModel)]="settings.generateAsPreview"
            (ngModelChange)="updateSettings()"

            optionLabel="label"
            optionValue="value" />
        }
      </div>
    </div>

    @if (offerSetVisibilityScopeEnabled) {
      <p-divider />

      <div class="setting-content">
        <span class="setting-name">
          Create Inventory Offer Sets for All {{label}} Inventory
          <i class="pi pi-question-circle"
             pTooltip="When enabled, an offer set will be created for every vehicle added to inventory. When disabled, offer sets are created based on the visibility scope below."
             tooltipPosition="top"></i>
        </span>
        <div class="ad-types-header-input">
          @if (settings) {
            <p-selectButton
              [options]="generateAllInventoryOptions"
              [(ngModel)]="settings.generateAllInventory"
              (ngModelChange)="updateSettings()"
              optionLabel="label"
              optionValue="value" />
          }
        </div>
      </div>
    }

    <p-divider />

    <div class="setting-content">
      <span class="setting-name">
        @if (!offerSetVisibilityScopeEnabled) {
          Build one offer set per
        } @else {
          Offer Set Visibility for Landing Pages & Offer Sets
          <i class="pi pi-question-circle"
             pTooltip="Controls how offer sets are surfaced in marketing and landing pages. Additional inventory offer sets may still be used only when needed for the specific vehicles. When inventory offer sets creation is disabled, this setting also controls how many offer sets are created."
             tooltipPosition="top"></i>
        }
      </span>
      <div class="ad-types-header-input">
        @if (settings) {
          <p-selectButton
            [options]="buildByOptions"
            [(ngModel)]="settings.cruiseControlCreateLevelId"
            (ngModelChange)="updateSettings()"

            optionLabel="label"
            optionValue="value" />
        }
      </div>
    </div>

    <p-divider />

    <div class="setting-content">
      <span class="setting-name">Vehicle Selection Criteria</span>
      <div class="ad-types-header-input">
        @if (settings && selectionCriteria.length > 0) {
          <p-select
            [options]="selectionCriteria"
            [(ngModel)]="settings.vehicleSelection"
            [disabled]="settings.cruiseControlCreateLevelId === 3"
            (ngModelChange)="updateSettings()"
            optionLabel="criteria"
            optionValue="id">
          </p-select>
        }
      </div>
    </div>

    <p-divider />

    <div class="setting-content">
      <span class="setting-name">Minimum Image Requirement</span>
      <div class="ad-types-header-input">
        @if (settings) {
          <p-select
            [options]="minimumImageOptions"
            [(ngModel)]="settings.minimumImageRequirement"
            (ngModelChange)="updateSettings()"
            optionLabel="label"
            optionValue="value">
          </p-select>
        }
      </div>
    </div>

  </div>

  <p-card class="controls">
    @if (!isInProgress(status)) {
      <p-button [disabled]="settings && !settings.enabled" label="Run Cruise Control" (click)="confirmRun($event)"/>
    }
    @if (isInProgress(status)) {
      <p-button label="Run Cruise Control" icon="pi pi-spin pi-spinner" [disabled]="true" />
    }

    @if (status && status.created) {
      <p-fieldset legend="Status">
        <p-stepper [value]="progressIndex + 1" [linear]="true">
          <p-step-list>
            <p-step [value]="1">Queued</p-step>
            <p-step [value]="2">In Progress</p-step>
            <p-step [value]="3">Done</p-step>
          </p-step-list>
        </p-stepper>
        <p-message *ngFor="let msg of commandMessages" [severity]="$any(msg.severity)" [text]="msg.detail" [closable]="false" />
        <p class="created-date">{{status.created | date: 'short' }}</p>
      </p-fieldset>
    }
  </p-card>
</div>
